export enum FormColumnsAmountTypes {
  one = 'one',
  two = 'two',
  three = 'three',
  four = 'four',
  five = 'five',
  six = 'six',
  seven = 'seven',
  eight = 'eight',
  nine = 'nine',
  ten = 'ten',
  eleven = 'eleven',
  twelve = 'twelve',
}
